import { useSidebar } from "../context/SidebarContext";
import styles from "./Topbar.module.css";
import { ReactComponent as SearchIcon } from "../assets/icons/searchtool.svg";
import NotificationBell from "./notifications/NotificationBell";

export default function Topbar() {
  const { collapsed } = useSidebar();

  return (
    <header
      className={styles.topbar}
      style={{ left: collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-w)" }}
    >
      <div className={styles.left}>
        <div className={styles.searchBox}>
          <span className={styles.searchIcon}><SearchIcon /></span>
          <input
            className={styles.searchInput}
            placeholder="Search nodes, policies, users…"
            type="text"
          />
        </div>
      </div>

      <div className={styles.right}>
        <NotificationBell />
      </div>
    </header>
  );
}